import { Icon } from '@chakra-ui/react';
import BulkActionBar, { BulkActionBarItem } from '../BulkActionBar';
import {
    getOrderBulkActions,
    OrderBulkActionId,
    OrderBulkPermissions,
    OrderBulkTarget,
} from '../../utils/orderBulkActions';
import { TbBookmark } from 'react-icons/tb';

const BulkSaveForLaterIcon = ({ filled }: { filled: boolean }) => (
    <Icon
        as={TbBookmark as React.ElementType}
        boxSize={4}
        color="currentColor"
        fill={filled ? 'currentColor' : 'transparent'}
        strokeWidth={filled ? 0 : 1.75}
    />
);

interface OrderBulkActionBarProps {
    selectedOrders: OrderBulkTarget[];
    permissions: OrderBulkPermissions;
    onClearSelection: () => void;
    onAction: (actionId: OrderBulkActionId) => void;
    isLoading?: boolean;
}

const OrderBulkActionBar = ({
    selectedOrders,
    permissions,
    onClearSelection,
    onAction,
    isLoading = false,
}: OrderBulkActionBarProps) => {
    const orderActions = getOrderBulkActions(selectedOrders, permissions);
    const actions: BulkActionBarItem[] = orderActions.map((action) => ({
        id: action.id,
        label: action.label,
        icon: action.icon as React.ElementType,
        renderIcon:
            action.id === 'flag' || action.id === 'unflag'
                ? () => <BulkSaveForLaterIcon filled={action.id === 'unflag'} />
                : undefined,
    }));

    return (
        <BulkActionBar
            selectedCount={selectedOrders.length}
            actions={actions}
            onClearSelection={onClearSelection}
            onAction={(actionId) => onAction(actionId as OrderBulkActionId)}
            isLoading={isLoading}
            shortcutEnabled
        />
    );
};

export default OrderBulkActionBar;
